<sc-activity-list-item [activity]="activity" [showProjectName]="showProjectName" [condensed]="condensed">
    <i scActivityIcon class="fa-sharp fa-solid fa-comment"></i>
    @if (activity?.Candidate) {
    {{ texts.commentedPrefix[language] }} @if (context != 'candidate') { <strong>{{ activity.Candidate?.FirstName }} {{ activity.Candidate?.LastName }}</strong> } {{ texts.commentedSuffix[language] }}
    } @else {
    {{ texts.commentedPosition[language] }}
    }
    <div scActivityBody>
        <p [innerHTML]="activity.Payload?.Body"></p>
    </div>
</sc-activity-list-item>
